/**
 * Name of the @gorhom/portal host rendered inside GalleryViewModal's native
 * (SlideSheet) content. The favorite/collection flow teleports its in-window
 * overlays here so they render inside the gallery modal's window instead of
 * stacking as nested RN Modals (which collapse when the keyboard opens).
 */
export const GALLERY_COLLECTION_OVERLAY_HOST = "galleryCollectionOverlay";
